import {inject, Injectable} from '@angular/core';
import {CampaignLoader} from '../../campaign/services/campaign.loader';
import {CustomerLoader} from '../../customer/services/customer.loader';
import {MileageLoader} from '../../mileage/services/mileage.loader';
import {ServiceCase} from '../../service-case/models/service-case';
import {ServiceContractLoader} from '../../service-contract/services/service-contract.loader';
import {WarrantyRestrictionLoader} from '../../warranty-restriction/services/warranty-restriction.loader';

@Injectable({
  providedIn: 'root'
})
export class VehicleDataLoader {
  private readonly campaignLoader: CampaignLoader = inject(CampaignLoader);
  private readonly customerLoader: CustomerLoader = inject(CustomerLoader);
  private readonly serviceContractLoader: ServiceContractLoader = inject(ServiceContractLoader);
  private readonly mileageLoader: MileageLoader = inject(MileageLoader);
  private readonly warrantyRestrictionLoader: WarrantyRestrictionLoader = inject(WarrantyRestrictionLoader);

  /**
   * Returns true if service case metadata changed & service case needs to be updated.
   */
  loadVehicleRelatedData(serviceCase: ServiceCase): Promise<boolean> {
    return new Promise(resolve => {
      // mileage needs to be loaded first, because it is relevant for service contract warnings
      this.mileageLoader.loadMileage(serviceCase)
        .then((mileageChanged: boolean): void => {
          this.loadMetadata(serviceCase)
            .then((metadataChanged: boolean): void => resolve(mileageChanged || metadataChanged));
        });
    });
  }

  /**
   * Returns true if any of the mileage dependent service case metadata changed.
   */
  private loadMetadata(serviceCase: ServiceCase): Promise<boolean> {
    return Promise.all([
      this.campaignLoader.loadCampaignsInServiceCase(serviceCase),
      this.serviceContractLoader.loadServiceContractsInServiceCase(serviceCase),
      this.warrantyRestrictionLoader.loadWarrantyRestrictionsInServiceCase(serviceCase),
      this.customerLoader.loadCustomerLanguageAndNumberInServiceCase(serviceCase),
      this.customerLoader.loadCustomersInServiceCase(serviceCase),
      this.customerLoader.loadLicensePlateInServiceCase(serviceCase)
    ])
      .then((metadataChanged: boolean[]): boolean => metadataChanged.some((changed: boolean): boolean => changed));
  }
}
